import React from "react";

const EnrollmentContentProgressBody = ({
  mode = "campaign",
  total,
  contentDone,
  profileDone,
  accountDone,
  accountSummary,
  percent,
}) => {
  const safeTotal = Number(total || 0);
  const safeContentDone = Math.min(Number(contentDone || 0), safeTotal);
  const safeProfileDone = Math.min(Number(profileDone || 0), safeTotal);
  const safeAccountDone = Math.min(Number(accountDone || 0), safeTotal);
  const safePercent = Math.min(100, Math.max(0, Number(percent) || 0));
  const showContent = mode === "campaign" || mode === "both";
  const showProfile = mode === "campaign" || mode === "both";
  const showAccount = mode === "account" || mode === "both";

  return (
    <div className="px-4 pb-3 pt-3">
      <div className="flex items-center gap-3">
        <div className="h-2 flex-1 overflow-hidden rounded-full bg-gray-200 dark:bg-gray-800">
          <div
            className="h-full rounded-full bg-secondary transition-[width] duration-500 ease-out"
            style={{ width: `${safePercent}%` }}
          />
        </div>
        <span className="w-9 text-right text-xs font-semibold text-secondary dark:text-secondary-light">
          {safePercent}%
        </span>
      </div>

      {(showContent || showProfile || showAccount) && (
        <div className="mt-3 space-y-1 text-xs text-gray-700 dark:text-gray-300">
          {showContent ? (
            <p>
              • <span className="font-semibold">Content:</span> {safeContentDone}/
              {safeTotal} complete
            </p>
          ) : null}
          {showProfile ? (
            <p>
              • <span className="font-semibold">Profile:</span> {safeProfileDone}/
              {safeTotal} complete
            </p>
          ) : null}
          {showAccount ? (
            <p>
              • <span className="font-semibold">Account:</span> {safeAccountDone}/
              {safeTotal} complete
            </p>
          ) : null}
          {showAccount && accountSummary ? (
            <p>
              • {accountSummary.selected} contact{accountSummary.selected === 1 ? "" : "s"} selected,{" "}
              {accountSummary.alreadyInAccounts + accountSummary.queued} unique{" "}
              {accountSummary.alreadyInAccounts + accountSummary.queued === 1 ? "company" : "companies"},{" "}
              {accountSummary.alreadyInAccounts} already in Accounts
            </p>
          ) : null}
        </div>
      )}
    </div>
  );
};

export default EnrollmentContentProgressBody;
